import React from 'react'

const TableFilterDropdown = ({ fieldName, displayField, filter, data, onChange }) => (
  <select onChange={onChange} style={{ width: '100%' }} value={filter}>
    <option value="" />
    {data
      .sort((a, b) => (a[displayField] > b[displayField] ? 1 : -1))
      .map((value) => (
        <option key={value[fieldName]} value={value[fieldName]}>
          {value[displayField]}
        </option>
      ))}
  </select>
)

export default TableFilterDropdown
